import { memo } from "react";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	availableItemIDs: ForArrayType<string[]>;
	rawAvailableItemIDs: string[];
	nameAndIDOptions: FormOptionType[];
	onSetAvailableItemIDs: (_input: CheckedState, item: FormOptionType) => void;

	title?: string;
	guide?: string;
};

export const QuestionPlanRoomConnection = memo(
	({
		availableItemIDs,
		rawAvailableItemIDs,
		nameAndIDOptions,
		onSetAvailableItemIDs,
		title: _title,
		guide: _guide,
	}: Props) => {
		const title = _title || "予約可能な部屋";
		const guide = _guide || "このプランで予約可能な部屋を選択しましょう";

		return (
			<QuestionConnection
				title={title}
				guide={guide}
				required={true}
				availableItemIDs={availableItemIDs}
				rawAvailableItemIDs={rawAvailableItemIDs}
				nameAndIDOptions={nameAndIDOptions}
				onSetAvailableItemIDs={onSetAvailableItemIDs}
			/>
		);
	},
);

QuestionPlanRoomConnection.displayName = "QuestionPlanRoomConnection";
